import React from "react";
import { Form } from "antd";
import OrderDTO from "@/dto/order/OrderDTO";
import CopiesFormItemV2 from "@/scenes/OrderManagement/components/dialogs/PrintWaybillDialog/components/CopiesFormItems/CopiesFormItemV2";
import SplitOrderItemByQuantityFormItem from "@/scenes/OrderManagement/components/dialogs/PrintWaybillDialog/components/CopiesFormItems/SplitOrderItemByQuantityFormItem";
import SplitOrderItemByWeightFormItem from "@/scenes/OrderManagement/components/dialogs/PrintWaybillDialog/components/CopiesFormItems/SplitOrderItemByWeightFormItem";

interface CopiesFormItemsProps {
    orders: OrderDTO[];
}

const CopiesFormItems: React.FC<CopiesFormItemsProps> = (props) => {
    const { orders } = props;

    return (
        <>
            <Form.Item label="面单数量：">
                <CopiesFormItemV2 orders={orders} />
            </Form.Item>

            <SplitOrderItemByQuantityFormItem />

            <SplitOrderItemByWeightFormItem />
        </>
    );
};

export default React.memo(CopiesFormItems);
